import React, { Component } from "react";
import './imageCanvas.scss';
import cover from '../../static/images/cover.png';
import canceltuoMin from '../../static/images/cancelTuoMin.gif';
import tuominAnimation from '../../static/images/tuomin.gif';
import revert from '../../static/images/revert.png';
import zoomIn from '../../static/images/zoomIn.png';
import zoomOut from '../../static/images/zoomOut.png';
import correct from '../../static/images/correct.png';
import deleteImage from '../../static/images/delete.png';
import warning from '../../static/images/warning.png';
import backArrow from '../../static/images/backArrow.png';
import handlerCanvas from './imageCanvas.js';
import classnames from 'classnames';
import axios from 'axios';
import { Toast, Modal, ActivityIndicator } from 'antd-mobile';

export default class DrawCanvas extends React.Component {
    state = {
      ctx: '',
      showPicture: true,
      showRatioDesc: false,
      ratioDesc: '',
      bottomOrDelete: true,
      showSensitiveMsg: false,
      backMsg: '',
      ocrReconized: true,
      showOcrReconized: false,
      ocrRecognizedInfo: '',
      showDeleteImage: true,
      loading: false,
      loadingMsg: '',
      showTuoMin: true,
      tuoMingIng: false,
      showBottomArea: true
    };
    constructor(props) {
        super(props);
    }
    shouldComponentUpdate(props) {
        return true;
    }
    componentDidMount() {
        if (!this.props.imgUrl) {
          return;
        }
        const _sensitiveData = this.props.sensitiveData;
        if (_sensitiveData && _sensitiveData.coordinate && (_sensitiveData.coordinate.length > 0)) {
            this.setState({
              showSensitiveMsg: true
              // backMsg: 'showLastSensitive' // 解决切换tab后，上传，删除，返回后不更新最后一个敏感信息的icon问题
            });
        }
        // this.getOcrInfo();
        // this.sensitiveData();
        const { deleteTargetCover, resetAllCover, toClearInterval } = 
          handlerCanvas(
          this.props.imgUrl.url,
          this.refs.canvas,
          this.refs.edit,
          this.refs.deleteImage,
          this.refs.revert,
          this.refs.zoomIn,
          this.refs.zoomOut,
          this.refs.complete,
          {
            isRecognize: true,
            isOcr: this.props.isOcr,
            isEditPhoto: this.props.isEditPhoto,
            sensitiveData: (this.props.sensitiveData && this.props.sensitiveData.coordinate) || [],
            reconizeData: this.props.reconizeData || {},
            imgData: this.props.itemData,
            formCode: this.props.formCode,
            version: this.props.version,
            needOcrRecongize: this.props.needOcrRecongize
          },
          (type, res, info) => {
              if (type === 'zoomRatio') {
                this.setState({
                  ratioDesc: res,
                  showRatioDesc: true
                });
                setTimeout(() => {
                  this.setState({
                    showRatioDesc: false
                  });
                }, 3000);
              }
              if (type === 'complete') {
                  this.completeAll(res);
              }
              if (type === 'toDeleteImage') {
                  this.confirmDelete();
                  // this.toDeleteImage();
              }
              if (type === 'showDeleteCoverBottom') {
                  res === 'show' && this.showDelete();
                  res === 'hide' && this.showBottom();
              }
              if (type === 'edit') {
                  res && this.showDeleteBtn(false);
                  !res && this.showDeleteBtn(true);
                  this.changeTuoMin(!res);
              }
              if (type === 'editComplete') {
                this.changeTuoMin(true);
              }
              if (type === 'ocrReconize') {
                if (res === 'init') {
                  this.setState({
                    showOcrReconized: true,
                    ocrReconized: false
                  });
                }
                if (res === 'finish') {
                  this.setState({
                    showOcrReconized: true,
                    ocrReconized: true,
                    ocrRecognizedInfo: info
                  });
                  setTimeout(() => {
                    this.setState({
                      showOcrReconized: false
                    });
                  }, 3000);
                }
              }
              if (type === 'showSensitive') {
                this.setState({
                  showSensitiveMsg: true,
                  backMsg: res
                });
              }
          }
        );
        this.deleteTargetCover = deleteTargetCover;
        this.resetAllCover = resetAllCover;
        this.toClearInterval = toClearInterval;
    }
    componentDidUpdate() {
    }
    toBack(backType = '', backMsg = '', backAction = '') {
      // this.setState({
      //    showPicture: !this.state.showPicture
      // });
      // 是自动上传点击进来的
      console.log('this.props.needOcrRecongize', this.props.needOcrRecongize);
      if (backType === 'doNothing' && this.props.needOcrRecongize) {
        backAction = 'deleteImage';
      }
      this.toClearInterval && this.toClearInterval();
      this.props.onClose && this.props.onClose(backType, this.state.backMsg || backMsg, backAction);
    }
    changeTuoMin(mState) {
      this.setState({
        showTuoMin: mState
      })
    }
    sensitiveData() {
      // /ocr/sensitive/field/
      let itemData = this.props.itemData;
      const postData = {
        "url": this.props.imgUrl.url.split('?')[0],
        "formCode": itemData.formCode,
        "version": itemData.version
      };
      axios.post("/ocr/ocr/sensitive/field", postData).then(res => {
        if ((res.data.code + '') === '0') {
        }
      })
    }
    completeAll(res) {
      // 未脱敏点完成直接返回
      let itemData = this.props.itemData;
      const postData = {
        "areaList": res,
        "fileUrl": this.props.imgUrl.url.split('?')[0],
        "formId": this.props.formId, // 44682
        "platform": 1, // 1为h5, 0为pc
        "subjectCode": itemData.subjectCode
      };
      // this.setState({
      //   loading: true,
      //   loadingMsg: '等待脱敏中……'
      // });
      if (res && res.length > 0) {
        this.setState({
          ratioDesc: '等待脱敏中......',
          showRatioDesc: true,
          tuoMingIng: true,
          showBottomArea: false // 脱敏过程隐藏底部
        });
      }
      axios.post("/file/image/desensitizate", postData).then(res => {
          // this.setState({
          //   loading: false,
          //   loadingMsg: ''
          // });
          if ((res.data.code + '') === '0') {
            setTimeout(() => {
              this.toBack();
            }, 500);
          } else {
            const msg = res.data.message || '脱敏异常';
            Toast.show(msg, 1);
          }
      })
      // axios.post("http://192.168.4.22:6060/file/image/desensitizate", postData)
    }
    getOcrInfo() {
      // axios.post("http://192.168.7.34:6060/ocr/ocr/img", {
      axios.post("http://192.168.7.34/ocr/ocr/img", {
        "formCode": "",
        "imgUrl": this.props.imgUrl.url.split('?')[0],
        "version": ""
      }).then(res => {
        if ((res.data.code + '') === '0') {
        } else {
        }
    })
    }
    toDeleteImage() {
      // axios.post("/file/image/deleteImage", {
      const _selectField = this.props.selectField;
      let _url = this.props.imgUrl.url;
      _url = (_url.indexOf('?') >= 0 ) ? _url.split('?')[0] : _url;
      let photoValue = this.props.photos.filter(val => {
          return !(val.url.indexOf(_url) >= 0);
      }).map(item => {
        let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
        return _originUrl;
      });
      let userInfo = sessionStorage.getItem('token');
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
        } catch (error) {
          userInfo = {};
        }
      } else {
        userInfo = {};
      }
      let deleteUrl = "/data/data/image/delete";
      // 上传后直接进来的,此时数据未保存数据库，删除需要单独处理
      let deleteAction = '';
      if (this.props.needOcrRecongize) {
        deleteUrl = "/data/data/image/delete/oss";
        photoValue = [_url]
        deleteAction = 'notUpdate';
      }
      axios.post(deleteUrl, {
        "formId": this.props.formId,
        "dataCode": _selectField.dataCode,
        "deCode": _selectField.deCode,
        "value": photoValue,
        "dataTenantCode": userInfo.tenantCode || ''
      }).then(res => {
        if ((res.data.code + '') === '0') {
          Toast.show('图片删除成功, 即将返回至上一页', 1);
          setTimeout(() => {
              this.toBack('deleteImage', '', deleteAction);
          }, 1000);
        } else {
          const msg = res.data.message || '删除异常';
          Toast.show(msg, 1);
        }
      })
    }
    confirmDelete() {
        Modal.alert(
          '删除图片', 
          '删除图片将放弃当前所有操作，同时图片无法恢复，是否确认删除？',
        [
          { text: '取消', onPress: () => {} },
          { text: '删除', onPress: () => this.toDeleteImage() },
        ])
    }
    deleteSelectedCover() {
      this.deleteTargetCover && this.deleteTargetCover();
      this.showBottom();
    }
    showBottom() {
      this.setState({
        bottomOrDelete: true
      });
    }
    showDelete() {
      this.setState({
        bottomOrDelete: false
      });
    }
    showBottomHideDelete() {
      this.resetAllCover && this.resetAllCover();
      this.setState({
        bottomOrDelete: true
      });
    }
    showDeleteBtn(mState) {
      this.setState({
        showDeleteImage: mState
      });
    }
    render() {
      const { ratioDesc, showRatioDesc, bottomOrDelete, ocrReconized,
              loading, loadingMsg
            } = this.state;
      return (
        <div className="image-canvas_content" style={{ display: this.state.showPicture ? '' : 'none' }}>
          <ActivityIndicator animating={loading} size={"small"} text={loadingMsg} toast />
          <div className="image-canvas_title">
            <div className="image-canvas_back" onClick={() => {this.toBack('doNothing');}}>
                {/* 返回 */}
                <img className="back-arrow" src={backArrow} alt="" />
            </div>
          </div>
          { this.state.showSensitiveMsg &&
            <div className="image-canvas_tuomin-desc">
                <div
                  className="image-canvas_tuomin-main"
                  >
                    <img className="icon" src={warning} />
                    <span className="word">图片中存在敏感信息，请检查并脱敏</span>
                </div>
            </div>
          }
          {
            <div className={classnames('image-canvas_tip-desc', this.state.showSensitiveMsg ? 'image-canvas_has-sensitive' : '')} style={{ display: this.state.showRatioDesc ? '' : 'none' }}>
                <div
                  className="image-canvas_ratio-desc"
                  dangerouslySetInnerHTML={{__html: ratioDesc}}
                  >
                </div>
            </div>
          }
          { !this.state.showRatioDesc && this.props.needOcrRecongize &&
            <div className={classnames('image-canvas_tip-desc', this.state.showSensitiveMsg ? 'image-canvas_has-sensitive' : '')} style={{ display: this.state.showOcrReconized ? '' : 'none' }}>
                <div
                  className="image-canvas_ocr-desc"
                  > 
                  {
                    !ocrReconized && 
                    <div>OCR识别中......</div>
                  }
                  {
                    ocrReconized && 
                    <div className="image-canvas_ocr-complete">
                      <img className="icon" src={correct} />
                      {/* <span className="word">OCR识别完成</span> */}
                      <span className="word">{this.state.ocrRecognizedInfo}</span>
                    </div>
                  }
                </div>
            </div>
          }
          {/* 有敏感信息时高度变化 */}
          <div className={classnames('image-canvas_main', this.state.showSensitiveMsg ? 'image-canvas_main-top' : '')}>
            <canvas className={this.state.tuoMingIng ? 'filter-blur' : ''} ref="canvas" id="canvas">
            </canvas>
          </div>
          <div style={{ display: this.state.showBottomArea ? '' : 'none' }}>
              <div className="image-canvas_bottom" style={{ display: this.state.bottomOrDelete ? '' : 'none' }}>
                  {
                    this.props.isEditPhoto && 
                    <div className="edit" ref="edit" id="edit">
                    { this.state.showTuoMin &&
                        <div>
                          <img className="img" src={cover} alt="" />
                          <div className="word">脱敏</div>
                        </div>
                      }
                      { !this.state.showTuoMin &&
                        <div>
                          <img className="img" src={tuominAnimation} alt="" />
                          <div className="word">取消脱敏</div>
                        </div>
                        // <img className="cancel-tuomin" src={canceltuoMin} alt="" />
                      }
                    </div>
                  }
                  <div className="revert"  ref="revert" id="revert">
                    <div>
                      <img className="img" src={revert} alt="" />
                      <div className="word">还原尺寸</div>
                    </div>
                  </div>
                  <div className="zoomIn"  ref="zoomIn" id="zoomIn">
                    <div>
                        <img className="img" src={zoomIn} alt="" />
                        <div className="word">放大</div>
                    </div>
                  </div>
                  <div className="zoomOut"  ref="zoomOut" id="zoomOut">
                    <div>
                          <img className="img" src={zoomOut} alt="" />
                          <div className="word">缩小</div>
                    </div>
                  </div>
                  <div className="deleteImage"
                      ref="deleteImage"
                      id="deleteImage"
                      // style={{ display: this.state.showDeleteImage ? '' : 'none' }}
                      // 现在都需要展示
                  >
                    <div>
                          <img className="img" src={deleteImage} alt="" />
                          <div className="word">删除图片</div>
                    </div>
                  </div>
                  <div className="complete" ref="complete" id="complete">
                    <div className="confirm-btn">
                      完成
                    </div>
                  </div>
                    {/* <div ref="delete" id="delete">删除</div> */}
              </div>
              <div className="image-canvas_delete" style={{ display: this.state.bottomOrDelete ? 'none' : '' }}>
                  <div className="cancel-delete" onClick={() => { this.showBottomHideDelete() }}>取消</div>
                  <div className="confirm-delete" onClick={() => { this.deleteSelectedCover() }} >删除</div>
              </div>
          </div>

        </div>
      );
    }
}